import { render, staticRenderFns } from "./AssemblyFilter.vue?vue&type=template&id=6f8c3ae7&scoped=true"
import script from "./AssemblyFilter.vue?vue&type=script&lang=js"
export * from "./AssemblyFilter.vue?vue&type=script&lang=js"
import style0 from "./AssemblyFilter.vue?vue&type=style&index=0&id=6f8c3ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c3ae7",
  null
  
)

export default component.exports